export function assetsHasErrored(bool) {
    return {
        type: 'ASSETS_HAS_ERRORED',
        hasErrored: bool
    };
}
export function assetsIsLoading(bool) {
    return {
        type: 'ASSETS_IS_LOADING',
        isLoading: bool
    };
}
export function assetsIsLoaded(bool) {
    return {
        type: 'ASSETS_IS_LOADED',
        isLoaded: bool
    };
}
export function assetsFetchDataSuccess(assets) {
    return {
        type: 'ASSETS_FETCH_DATA_SUCCESS',
        assets
    };
}

export function preloadingDone(bool) {
    return {
        type: 'PRELOADING_DONE',
        payload: bool
    };
}

export function fetchAssetsData(url) {
    return (dispatch) => {
        dispatch(assetsIsLoading(true));
    	fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(assetsIsLoading(false));
                return response;
            })
            .then((response) => response.json())
            .then((assets) => dispatch(assetsFetchDataSuccess(assets)))
            .then(() => dispatch(assetsIsLoaded(true)))
            // .then(() => dispatch(preloadingDone(true)))
            .catch(() => dispatch(assetsHasErrored(true)));
    };
}


// WEBPACK FOOTER //
// ./src/actions/assets.js